import { render, staticRenderFns } from "./LegalModal.vue?vue&type=template&id=56852494&scoped=true"
import script from "./LegalModal.vue?vue&type=script&lang=js"
export * from "./LegalModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56852494",
  null
  
)

export default component.exports